import React, { FC } from "react";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";
import Desktop from "evcharging/components/Desktop";
import RatesQuoteButton from "containers/retail/sections/energy-rates-3/RatesQuoteButton";
import RatesBestIcon from "components/icons/RatesBestIcon";
import { Plan } from "services/quotes/types";
import RatesDesktopBestPlans from "containers/retail/sections/energy-rates-3/RatesDesktopBestPlans";
import Spacer from "evcharging/components/Spacer";
import Mobile from "evcharging/components/Mobile";
import RatesMobileBestPlans from "containers/retail/sections/energy-rates-3/RatesMobileBestPlans";
import useI18n from "evcharging/hooks/useI18n";

interface RatesBestPlansProps {
  locationText: string;
  toggleModal: () => void;
  bestPlans: Plan[];
  isLoading: boolean;
  onSelectPlan: (plan: Plan) => void;
}

const RatesBestPlans: FC<RatesBestPlansProps> = (props) => {
  const { locationText, toggleModal, bestPlans, onSelectPlan } = props;

  const { t } = useI18n();

  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <>
      <div className={styles.root}>
        <div className={styles.header}>
          <div className={styles.left}>
            <RatesBestIcon />
            <h2>{t('rate.best-plans-in-location', { location: locationText })}</h2>
          </div>
          <Desktop>
            <RatesQuoteButton onClick={toggleModal}>{t('rate.get-custom-quote')}</RatesQuoteButton>
          </Desktop>
        </div>
      </div>

      <Spacer value={36} />

      <Desktop>
        <RatesDesktopBestPlans bestPlans={bestPlans} handleSelectPlan={onSelectPlan} />
      </Desktop>
      <Mobile>
        <RatesMobileBestPlans bestPlans={bestPlans} handleSelectPlan={onSelectPlan} />
        <Spacer value={36} />
        <div className={styles.getQuoteBox}>
          <RatesQuoteButton onClick={toggleModal}>{t('rate.get-custom-quote')}</RatesQuoteButton>
        </div>
      </Mobile>
    </>
  );
};

const createStyles = (theme: Theme) => (
  {
    root: css`
      flex-grow: 1;
    `,
    left: css`
      display: flex;
      align-items: center;
    `,
    header: css`
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      margin-bottom: 12px;
      padding: 12px 20px;
      background-color: white;
      box-shadow: 0 3px 5px rgba(0, 0, 0, .05);
      border-radius: 6px;
      height: 62px;

      h2 {
        display: inline-block;
        margin-left: 6px;
        font-size: 21px;
        font-family: Mulish, sans-serif;

        ${theme.breakpoints.mobile.down} {
          font-size: 18px;
        }
      }

      svg {
        margin-right: 6px;
      }
    `,
    getQuoteBox: css({
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      marginTop: theme.spacing(3.75),
      marginBottom: theme.spacing(3.75),
      padding: theme.spacing(2, 2.5),
      backgroundColor: 'white',
      boxShadow: '0 3px 5px rgba(0, 0, 0, .05)',
      borderRadius: 6,
    })
  }
);

export default RatesBestPlans;
